/**
 * Mapping of die sides to their icon components
 * Extracted from DiceIcons.tsx to fix Fast Refresh warning
 */
import type { ComponentType } from 'react';
import {
  D4Icon,
  D6Icon,
  D8Icon,
  D10Icon,
  D12Icon,
  D20Icon,
  D100Icon,
} from './DiceIcons';

interface DiceIconProps {
  className?: string;
}

/** Map of die sides to their icon components */
export const DICE_ICON_COMPONENTS: Record<number, ComponentType<DiceIconProps>> = {
  4: D4Icon,
  6: D6Icon,
  8: D8Icon,
  10: D10Icon,
  12: D12Icon,
  20: D20Icon,
  100: D100Icon,
};
